<template>
	<modal inlineBlock v-model="isOpen" container-style="max-width: 100%; width: 800px;" :container-style="mq.current >= mq.md ? '' : 'top:20px'">
		<span slot="label" @click.prevent.stop="isOpen = true" class="glyphicon glyphicon-info-sign help" :title="tsl('TITLE')" />
		<div class="stock-legend" style="">
			<h2 style="margin: 5px 0">{{ tsl('TITLE') }}</h2>
			<p style="color: #969BA0; font-size: 0.9em; font-weight: bold; margin: 0">{{ tsl('LEGEND') }}</p>
			<table class='table table-striped table-condensed'>
				<tbody>
					<tr>
						<td>
							<div class="td-wrapper">
								<div class="stock-icon-instock stock-icon-legend"></div> 
								<span>X st</span>
							</div>
						</td>
						<td>{{ tsl('IN_STOCK') }}</td>
					</tr>
					<tr>
						<td>
							<div class="td-wrapper">
								<div class="stock-icon-outofstock-incentral stock-icon-legend"></div> 
								<span>X dagar</span>
							</div>
						</td>
						<td>{{ tsl('IN_CENTRAL') }}<sup>1</sup></td>
					</tr>
					<tr>
						<td>
							<div class="td-wrapper">
								<div class="stock-icon-in-supplier-stock stock-icon-legend"></div>
								<span>X st</span>
							</div>
						</td>
						<td>{{ tsl('IN_SUPPLIER_STOCK') }}</td>
					</tr>
					<tr>
						<td>
							<div class="td-wrapper">
								<div class="stock-icon-outofstock stock-shape-legend"></div> 
								<span style="margin-right: 2px;">Ej i lager</span><span>(ÅÅÅÅ-MM-DD)</span>
							</div>
						</td>
						<td>{{ tsl ('OUT_OF_STOCK') }}</td>
					</tr>
					<tr>
						<td>
							<div class="td-wrapper">
								<div class="stock-icon-outofstock stock-shape-legend"></div> 
								<span>Beställningsvara</span>
							</div>
						</td>
						<td>{{ tsl ('CAN_BE_ORDERED') }}</td>
					</tr>
					<tr>
						<td>
							<div class="td-wrapper">
								<div class="stock-icon-notreleased stock-shape-legend"></div> 
								<span>ÅÅÅÅ-MM-DD</span>
							</div>
						</td>
						<td>{{tsl ('NOT_RELEASED') }}<sup>2</sup></td>
					</tr>
				</tbody>
			</table>
			<p class="muted">1. {{ tsl('NOTE_1') }}</p>
			<p class="muted">2. {{ tsl('NOTE_2') }}</p>
		</div>
	</modal>
</template>

<script>
import mq from 'mediaQuery';
import { t } from 'datastore/i18n';

export default {
	data () {
		return {
			tsl: t.prefix('STOCK.LEGEND'),
			mq,
			isOpen: false,
		};
	},
};
</script>